import { __assign } from "tslib";
import React, { Suspense, lazy } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import { useIsMounted } from '../../utils/hooks/useIsMounted';
import retry from '../../utils/webpack/chunkRetry';
var Editor = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "editor-fallback" */
        './Fallback');
    });
});
export var LoadableFallback = function (props) {
    var mounted = useIsMounted();
    if (!mounted) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "FallbackEditor" },
        React.createElement(Suspense, { fallback: null },
            React.createElement(Editor, __assign({}, props)))));
};
LoadableFallback.displayName = 'LoadableFallback';
export default LoadableFallback;
//# sourceMappingURL=LoadableFallback.js.map